import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css2?family=Gabarito" />
    <App />
  </React.StrictMode>
);

